import { EmployeeAccessTypes } from '@shared/enums';

export const DeviceAdminAccessType: EmployeeAccessTypes =
  EmployeeAccessTypes.DeviceAdmin | EmployeeAccessTypes.PayAtTablePartial | EmployeeAccessTypes.PayAtTableFull;

export const LocationAdminAccessType: EmployeeAccessTypes =
  DeviceAdminAccessType |
  EmployeeAccessTypes.LocationAdmin |
  EmployeeAccessTypes.OfferAdmin |
  EmployeeAccessTypes.OrderAdmin |
  EmployeeAccessTypes.LoyaltyProgramAdmin |
  EmployeeAccessTypes.QuestionAdmin |
  EmployeeAccessTypes.ReportAdmin |
  EmployeeAccessTypes.ConsumerAccess |
  EmployeeAccessTypes.ConsumerReward |
  EmployeeAccessTypes.SaleOverview |
  EmployeeAccessTypes.ProductAdmin |
  EmployeeAccessTypes.TabletopAdmin;

export const FullAdminAccessType: EmployeeAccessTypes =
  LocationAdminAccessType |
  EmployeeAccessTypes.EmployeeAdmin |
  EmployeeAccessTypes.BillingAdmin |
  EmployeeAccessTypes.SendReceiveMessages;

export interface EmployeeAccessTypeOption {
  key: 'device-admin' | 'location-admin' | 'full-admin';
  name: string;
  value: EmployeeAccessTypes;
}

export const DeviceAdminOption: EmployeeAccessTypeOption = {
  key: 'device-admin',
  name: 'Device Admin',
  value: DeviceAdminAccessType,
};

export const LocationAdminOption: EmployeeAccessTypeOption = {
  key: 'location-admin',
  name: 'Location Admin',
  value: LocationAdminAccessType,
};

export const FullAdminOption: EmployeeAccessTypeOption = {
  key: 'full-admin',
  name: 'Full Admin',
  value: FullAdminAccessType,
};

export const EmployeeAccessTypeOptions: EmployeeAccessTypeOption[] = [
  DeviceAdminOption,
  LocationAdminOption,
  FullAdminOption,
];

export function mapEmployeeAccessTypeToOption(
  accessType: EmployeeAccessTypes | null | undefined
): EmployeeAccessTypeOption {
  switch (accessType) {
    case FullAdminAccessType:
      return FullAdminOption;
    case LocationAdminAccessType:
      return LocationAdminOption;
    case DeviceAdminAccessType:
    default:
      return DeviceAdminOption;
  }
}
